import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hc-aggregate-multi",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    types: ["Number"],
  },

  dataFetching: {
    history: true,
    historyRequired: true,
  },
  hideDataFilter: true,
  presets: [
    {
      label: "highcharts:explorer.aggregate.multi.title",
      description: "highcharts:explorer.aggregate.multi.description",
      layout: [6, 24],
      tags: ["charttime"],
      imageLink: async () => (await import("./res_034")).default,

      widget: {
        config: {
          aggregationOperation: "avg",
          interval: "hour",
          interaction_legend: true,
        },
      },
    },
  ],
});
